var _defs, _path, _polyline, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 50 50 50 50 0 0 0 0 50 0 50",
    fill: "none",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,24.51A24.75,24.75,0,0,1,25,0h0A24.75,24.75,0,0,1,50,24.51v1A24.75,24.75,0,0,1,25,50h0A24.75,24.75,0,0,1,0,25.49Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15.33 25.12 24.87 15.76 34.42 25.12",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.09,23.86a1.21,1.21,0,0,1,1.22-1.2H31.44a1.21,1.21,0,0,1,1.22,1.2v8.93A1.21,1.21,0,0,1,31.44,34H18.31a1.21,1.21,0,0,1-1.22-1.2Z",
    transform: "translate(0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24.83 16.01 17.34 23.13 32.41 23.15 24.83 16.01 24.83 16.01 24.83 16.01",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.c26085462511ae6e71d8dce672254f6f.svg";
export { ForwardRef as ReactComponent };